import { randomInt,validateResponse,jsonify,logError } from "./utils";
import List from "./Infolist"
import icon from "../assets/images/icon-location.svg";
const dotenv = require("dotenv").config();


/*----------------------------------------*\
  #search-bar 
\*----------------------------------------*/
export default class SearchForm{

    constructor(){
        this._loading = true;
        this.inforList = new List();
    // initilizing dom nodes 
     if(this._validateDomNodes()){
        this._render();
     }else{
         return;
     }
    }

    _validateDomNodes(){
        // dom caching search form 
        this.ipTracker = document.querySelector(".ip-tracker-wrapper")
        this.ipTrackerForm = this.ipTracker.querySelector(".ip-tracker__form");
        this.ipTrackerBtn = this.ipTracker.querySelector(".ip-tracker__btn");
        this.ipTrackerInput = this.ipTracker.querySelector(".ip-tracker__input");
        this.ipTrackerInfoListWrapper = this.ipTracker.querySelector(".ip-tracker__info-wrapper");
        this.ipTrackerInfoList = this.ipTracker.querySelector(".ip-tracker__info");
        this.ipTrackerInfoListError = this.ipTracker.querySelector(".ip-tracker__info-error");

        this.ipTrackerLoader = this.ipTracker.querySelector(".loader");

        if (this.ipTracker && this.ipTrackerForm && this.ipTrackerBtn && this.ipTrackerInfoListWrapper && 
            this.ipTrackerInput && this.ipTrackerLoader && this.ipTrackerInfoList){
            return true;
        }else{
            throw Error("required dom nodes are not available.");
        }
    }

    // bind events 
    _bindEnvents(){
        this.ipTrackerBtn.addEventListener('click', () => {
            this.ipTrackerBtn.classList.toggle("ip-tracker__btn--active");
            this.ipTrackerForm.classList.toggle("ip-tracker__form--active");
            this.ipTrackerInput.classList.toggle("ip-tracker__input--active");
            this.ipTrackerInfoListWrapper.classList.toggle("ip-tracker__info-wrapper--active");
            this.ipTrackerInfoList.classList.toggle("ip-tracker__info--active");
            this.ipTrackerBtn.title = "open"
        });

        // activates the loader
        this.ipTrackerLoader.classList.add("loader--active");

        // form evaluation 
        this.ipTrackerForm.addEventListener("submit",(e) => {
            e.preventDefault();

            if(this.isValidIp(this.ipTrackerInput.value)){
                this.ipTrackerInfoListError.classList.remove("ip-tracker__info-error--active");
                this.ipTrackerInfoList.classList.remove("ip-tracker__info--error");

                this._updateState(`https://geo.ipify.org/api/v1?apiKey=${process.env.API_KEY_GET}=
                ${this.ipTrackerInput.value}`);

            }else if(this.isValidDomain(this.ipTrackerInput.value)){
                this.ipTrackerInfoListError.classList.remove("ip-tracker__info-error--active");
                this.ipTrackerInfoList.classList.remove("ip-tracker__info--error");

                this._updateState(`https://geo.ipify.org/api/v1?apiKey=${process.env.API_KEY}&domain=
                ${this.ipTrackerInput.value}`)

            }else{
                this.ipTrackerInfoListError.classList.add("ip-tracker__info-error--active");
                this.ipTrackerInfoList.classList.add("ip-tracker__info--error");
            }

        })
    }

    convertIpToG(ip){
        return {"ip":ip.toString()};
    }
    
    isValidIp(ip){
        const pattern = '(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[0-9][0-9]?|0)';
        const ipRegex = new RegExp(`^${pattern}\\.${pattern}\\.${pattern}\\.${pattern}$`);
        return ipRegex.test(ip)
    }

    isValidDomain(domain){
        const pattern = "^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\\.)+[A-Za-z]{2,6}$";
        const domainRegex = new RegExp(pattern);
        return domainRegex.test(domain)
    }

    /*
    * update the state by fetching the api with url 
    * remove the old map and creats a new one based on the new state
    * update the inforList object with new state
    */    
    _updateState(url){
        this._load();
        fetch(url)
        .then(validateResponse)
        .then(jsonify)
        .then( data => {
            const {as:{asn:asnNumber},ip,isp,location:{country,city,region,timezone,lat:longitude,lng:latitude}} = data;
            const state = {ip,isp,country,asnNumber,city,region,timezone,longitude,latitude}
            this.map.remove();
            this._endLoading();
            this.inforList.updateDomNodes(state);
            this._createMap(state)
        })
        .catch(logError)
    }




    // render method 
    _render(){
        this._bindEnvents();

      
   }


   _load(){
    this.ipTrackerLoader.classList.add("loader--active");
    this.ipTrackerInfoList.classList.remove("ip-tracker__info--active");
   }


   _endLoading(){
    this.ipTrackerLoader.classList.remove("loader--active");
    this.ipTrackerInfoList.classList.add("ip-tracker__info--active");

   }

    // creating the map 
    _createMap({longitude,latitude}){

        // map configurations 
        this.map = L.map('ip-tracker__map', {
            zoom: 14,
            center:[latitude,longitude],
            worldCopyJump:true,
        });

      
        this.map.setView([randomInt(),randomInt()]);
        this.map.flyTo([longitude,latitude])

        // location icon 
        let location = L.icon({
            iconUrl: icon,
            iconSize:     [47, 55], 
            iconAnchor:   [longitude, latitude], 
            popupAnchor:  [-30, 20],
            className: location,
            inertia: true,
            worldCopyJump:true,
        });

        L.marker([longitude,latitude], 
            {
            icon: location,
            alt: "loaction"
        }).addTo(this.map).bindPopup("we are here") 


        // binding a popup to the icon 

        // layer 
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{map}', 
        {map: 'bar', 
        zoom: 12,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
        
    }

    
    // updating the map 
    update(state){
        this._endLoading();
        this._createMap(state);
        this.inforList.updateDomNodes(state)

    }
}